import { useSelector } from "react-redux";
import { Option } from "../Option/Barcode";
import { useMemo, useState } from "react";
import { IsNumber } from "../../utils/isNumber";
import Swal from "sweetalert2";
import { BarcodeActivation_API } from "../../APIs/BarcodeActivation.api";
import { useNavigate } from "react-router-dom";

const INPUT = [
  {
    label: "Mã Sản Phẩm",
    required: true,
    table_id: 21692,
    primary_key: 21693,
    fomular_alias: "msp",
    displayFields: [
      {
        label: "Mã Sản Phẩm-22MSP",
        value: "22MSP",
      },
      {
        label: "Tên Sản Phẩm-10TSP",
        value: "10TSP",
      },
    ],
  },
  {
    label: "Lệnh Đóng Bao",
    fomular_alias: "ldb",
    displayFields: [
      {
        label: "Mã Lịch Đóng Bao-1MLĐB",
        value: "1MLĐB",
      },
    ],
    required: true,
    table_id: 22587,
    primary_key: 22588,
    // displayFields: undefined,
  },
  {
    label: "Dây chuyền sản xuất",
    fomular_alias: "lsx",
    table_id: 4110611,
    primary_key: 4110612,
    displayFields: [
      {
        label: "Mã Line sản xuất-IDLSX",
        value: "IDLSX",
      },
      {
        label: "Tên Line sản xuất-TenLSX",
        value: "TenLSX",
      },
    ],
    required: true,
  },
  {
    label: "Vị trí bắt đầu",
    fomular_alias: "from",
    required: true,
  },
  {
    label: "Vị trí kết thúc",
    fomular_alias: "to",
    required: true,
  },
  {
    label: "Ghi Chú",
    fomular_alias: "note",
  },
];

export const BarCodeActivation = ({
  props = { table: [], updated_fields: [] },
  title_list,
  othersPayload,
}) => {
  const { lang, proxy } = useSelector((state) => state);
  let navigate = useNavigate();
  const [info, setInfo] = useState([]);
  const [isCallInfo, setCallInfo] = useState(false);
  const [refresh, setRefresh] = useState(0);

  const {
    updated_fields,
    table: [],
  } = props;

  const input_list = [
    {
      label: "Từ:",
      key: "from",
      alias: "From field",
    },
    {
      label: "Đến:",
      key: "to",
      alias: "To field",
    },
  ];

  const [data, setData] = useState();

  const { fields, foreign_keys } = useMemo(() => {
    return props.table?.reduce(
      (prev, { value: { fields, foreign_keys } }) => {
        prev.fields.push(...fields);
        prev.foreign_keys.push(...foreign_keys);
        return prev;
      },
      { fields: [], foreign_keys: [] }
    );
  }, [props.table]);

  const mapped_foreign_fields = useMemo(() => {
    const list = [];
    const data = {};

    for (const index in updated_fields) {
      const {
        field: { field_name, value: id },
        isVisible,
        defaultValue,
        isSelect,
        displayFields,
      } = updated_fields[index];
      const field = fields?.find(({ id: _id }) => _id === id) || {};

      if (field?.fomular_alias) {
        data[field.fomular_alias] = defaultValue;
      }

      if (isVisible) {
        const foreign_field = foreign_keys?.find(
          ({ field_id }) => field_id === id
        );
        if (foreign_field) {
          field["ref_table_id"] = foreign_field.table_id;
          field["ref_field_id"] = foreign_field.ref_field_id;
        }
        if (field) {
          list.push({ ...field, isSelect, field_name, displayFields });
        }
      }
    }
    setData((prev) => ({ ...prev, payload: data }));
    return list;
  }, []);

  const { database } = useSelector((s) => s);

  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault();

          const ERROR = [];

          for (const { fomular_alias, required, label } of INPUT) {
            if (required && !data?.[fomular_alias]?.trim()) {
              ERROR.push(label);
            }
          }

          // for (const index in mapped_foreign_fields) {
          //   const { fomular_alias, field_name, NULL } =
          //     mapped_foreign_fields[index];
          //   if (mappedData[fomular_alias] === null && NULL === false) {
          //     ERROR.push(field_name);
          //   }
          // }

          if (ERROR.length) {
            Swal.fire({
              title: lang["error"],
              text: `${ERROR.join(", ")}: không được trống!`,
              icon: "error",
              showConfirmButton: true,
              confirmButtonText: true,
              allowOutsideClick: false,
            });
            return;
          }

          Swal.fire({
            title: "Đang kích hoạt",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          BarcodeActivation_API.post(proxy(), "/api/LSKH", {
            ...data,
            mlsx: title_list[0].value,
          })
            .then((res) => {
              let title = lang["success"];
              let text = "Activating barcode successfully";
              let icon = "success";
              let showConfirmButton = false;
              let confirmButtonText = lang["confirm"];
              let timer = 1500;
              const { success } = res;

              if (success) {
                setCallInfo(true);
                setRefresh((prev) => prev + 1);
              } else {
                title = lang["fail"];
                text = res.errors?.description;
                icon = "error";
                showConfirmButton = true;
                timer = 0;
              }

              Swal.fire({
                title,
                text,
                icon,
                showConfirmButton,
                confirmButtonText,
                timer,
                allowOutsideClick: false,
              });
              setData({});
            })
            .catch((e) =>
              Swal.fire({
                title: lang["error"],
                text: `Thất bại`,
                icon: "error",
                showConfirmButton: false,
                timer: 1500,
              })
            );
        }}
      >
        <h4 className="my-4 mx-4">Kích hoạt TID</h4>
        <div className="preview p-3 d-flex align-items-center flex-column">
          <div
            class="d-flex align-items-center mt-2"
            style={{ fontWeight: "bold" }}
          >
            {/* {props.name} */}
          </div>
          {/* {title_list?.map((title, i) => (
          <h5 className="" key={i}>
            {title}
          </h5>
        ))} */}

          <section
            style={{
              ...props.style,
              gap: "20px",
              "max-width": "500px",
            }}
            className="d-flex flex-column"
          >
            {title_list.map((title, i) => (
              <section key={i} className="d-flex justify-content-between">
                <h5 key={i}>{title.field_name}:</h5>
                <h5
                  style={{
                    "min-width": "300px",
                  }}
                >
                  {title.value}
                </h5>
              </section>
            ))}
            {INPUT.map(
              ({
                label,
                displayFields,
                primary_key,
                required,
                table_id,
                fomular_alias,
              }) => {
                let cpn = <></>;
                if (table_id) {
                  cpn = (
                    <Option
                      key={refresh}
                      label={label}
                      onChange={({ label, value }) => {
                        setData((prev) => ({
                          ...prev,
                          [fomular_alias]: value,
                        }));
                      }}
                      primary_key={primary_key}
                      table_id={table_id}
                      displayFields={displayFields}
                    />
                  );
                } else {
                  cpn = (
                    <input
                      key={refresh}
                      type="text"
                      className="form-control"
                      style={{
                        "max-width": "300px",
                      }}
                      onChange={({ target: { value } }) => {
                        let result = value;

                        if (["INT UNSIGNED", "INT"].includes(props.DATATYPE)) {
                          result = Number(result);
                        }

                        setData((prev) => ({
                          ...prev,
                          [fomular_alias]: value,
                        }));
                      }}
                    />
                  );
                }

                return (
                  <section
                    className="d-flex align-items-center justify-content-between"
                    style={{
                      gap: "10px",
                    }}
                  >
                    <label
                      className="font-weight-bold"
                      style={{
                        "min-width": "100px",
                      }}
                    >
                      {label}
                      {required ? <span className="red_star">*</span> : null}:
                    </label>
                    {cpn}
                  </section>
                );
              }
            )}

            <section className="d-flex justify-content-end">
              <button type="submit" class="btn btn-success mr-2">
                {lang["btn.update"]}
              </button>
              <button
                type="button"
                onClick={(e) => {
                  // e.preventDefault();
                  // e.stopPropagation();
                  const oldUrl = sessionStorage.getItem("oldUrl");
                  navigate(oldUrl);
                }}
                class="btn btn-danger mr-2"
              >
                {lang["btn.close"]}
              </button>
            </section>
          </section>
        </div>
      </form>
      {/* <div className="d-flex justify-content-center">
        <table className="table-custom w-100 col-sm-6">
          <thead>
            <tr>
              <td>aaaa</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div> */}
    </>
  );
};
